"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSidebarPopoverButton = void 0;
var style_utils_1 = require("@nef/style-utils");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var PopoverButton_1 = __importDefault(require("../../../PopoverButton"));
var FontAwesomeIcon_1 = require("../../../FontAwesomeIcon");
var Text_1 = __importDefault(require("../../../Text"));
var PopoverButtonText_1 = require("../../../PopoverButton/components/PopoverButtonText");
var innerFunction = function (_a) {
    var icon = _a.icon, iconSetClassName = _a.iconSetClassName, iconClassName = _a.iconClassName, innerAs = _a.innerAs, props = __rest(_a, ["icon", "iconSetClassName", "iconClassName", "innerAs"]);
    return (react_1.default.createElement(PopoverButton_1.default, __assign({ as: innerAs }, props)));
};
exports.StyledSidebarPopoverButton = styled_components_1.default(innerFunction)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n\n  &:active,\n  &:focus {\n    background: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n\n    ", " {\n      color: ", ";\n    }\n  }\n\n  &:active,\n  &:focus,\n  &:hover {\n    ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ",\n  ", " {\n    color: ", ";\n  }\n"], ["\n  background: ", ";\n  color: ", ";\n\n  &:active,\n  &:focus {\n    background: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n\n    ", " {\n      color: ", ";\n    }\n  }\n\n  &:active,\n  &:focus,\n  &:hover {\n    ",
    ";\n  }\n\n  ",
    ";\n\n  ",
    ";\n\n  ", ",\n  ", " {\n    color: ", ";\n  }\n"])), style_utils_1.getSidebarColor(0), style_utils_1.getSidebarColor(900), style_utils_1.getSidebarColor(50), style_utils_1.getSidebarColor(25), FontAwesomeIcon_1.StyledFontAwesomeIcon, style_utils_1.getSidebarColor(900), function (props) {
    return props.disabled && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        color: ", ";\n      "], ["\n        color: ", ";\n      "])), style_utils_1.getSidebarColor(400)(props));
}, function (props) {
    return props.active && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background: ", ";\n      outline: none;\n      font-weight: 500;\n    "], ["\n      background: ", ";\n      outline: none;\n      font-weight: 500;\n    "])), style_utils_1.getSidebarColor(50));
}, function (props) {
    return props.disabled && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      color: ", ";\n\n      ", " {\n        color: ", ";\n      }\n    "], ["\n      color: ", ";\n\n      ", " {\n        color: ", ";\n      }\n    "])), style_utils_1.getSidebarColor(400), Text_1.default, style_utils_1.getSidebarColor(400));
}, FontAwesomeIcon_1.StyledFontAwesomeIcon, PopoverButtonText_1.StyledPopoverButtonText, style_utils_1.getSidebarColor(900));
var SidebarPopoverButton = function (_a) {
    var className = _a.className, props = __rest(_a, ["className"]);
    return (react_1.default.createElement(exports.StyledSidebarPopoverButton, __assign({}, props, { className: style_utils_1.classNames("sidebar--popover-button", className) })));
};
exports.default = SidebarPopoverButton;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map